import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import { AppService } from '../../app.service';
import { SecurityModelHistoryGridLayoutService } from './security-model-history.grid-layout.service';
import { IrbEditorsService } from '../irb-editors.service';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { IrbAgGridExportService } from '../../irb-common/components/irebal-ag-grid-ent-avatar/irb-ag-grid-export/irb-ag-grid-export.service';
import { ISecurityModelHistory } from '../irb-editors.model';
import { DatePipe } from '@angular/common';
import { EasternTimePipe } from '../../irb-common/pipes/EasternTimePipe';

@Component({ standalone: false,
    selector: 'irb-security-model-history',
    templateUrl: './security-model-history.component.html',
    styleUrls: ['./security-model-history.component.scss'],
    providers: [DatePipe, EasternTimePipe]
})
export class SecurityModelHistoryComponent implements OnChanges, OnInit {

    faDownload = faDownload;
    rowCount: number;
    gridOptions: any;
    sideBar: any;
    private grid: any;
    isUiTest = false;
    frameworkComponents: any;

    @Input()
    data: any;

    @Input()
    modelType: string;

    @Input()
    createModifyData: any;

    constructor(
        private smhgls: SecurityModelHistoryGridLayoutService,
        private as: AppService,
        protected ies: IrbEditorsService,
        public ges: IrbAgGridExportService,
        private datePipe: DatePipe,
        private easternTimePipe: EasternTimePipe
    ) {
    }

    ngOnInit(): void {
        let colDef = this.smhgls.getSecColumnDefs();

        if (this.modelType === 'Blended') {
            colDef = this.smhgls.getBlendedHistoryColumnDefs();
        }

        this.gridOptions = {            
            columnDefs: colDef,
            context: {componentParent: this},
            floatingFilter: false,
            suppressHorizontalScroll: true
        };
        
        this.frameworkComponents = this.smhgls.getFrameworkComponents();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.data) {
            this.load();
        }
    }

    load() {
        if (this.data && this.grid) {
            this.grid.api.setGridOption('rowData', this.data);
            this.rowCount = (this.data) ? this.data.length : 0;
        }
    }

    onGridReady(params: any) {
        this.grid = params;
        this.load();
    }

    exportModelHistory() {
        let colDef = this.smhgls.getSecColumnDefs();
        let columnKeys = [];
        if (this.modelType === 'Blended') {
            colDef = this.smhgls.getBlendedHistoryColumnDefs();
        }
        for (let i = 0; i < colDef.length; i++) {
            const col = colDef[i];
            if (col.field === 'modelName') {
                col.headerName = "Security Model Name";
            }
            columnKeys.push(col.field);
        }
        const modelNameCol = {headerName: "Model Name", field: "modelNameExport", cellRenderer: "cellRendererFormatter"} as any ;
        colDef.unshift(modelNameCol);
        columnKeys.unshift('modelNameExport');


        const formatter = (res: ISecurityModelHistory[]) => {
            res.forEach((r: any) => {
                r.createdDate = this.datePipe.transform(this.easternTimePipe.transform(r.createdDate), 'MM/dd/yyyy h:mm a') + ' ET';
                r.modelNameExport = this.createModifyData.modelName || '';
                r.modelNameExport = (r.modelNameExport.includes(",") || r.modelNameExport.includes('"')) ? '"' + r.modelNameExport.replaceAll(/"/g, '""') + '"' : r.modelNameExport;

                if (r.modelName) {
                    r.modelName = (r.modelName.includes(",") || r.modelName.includes('"')) ? '"' + r.modelName.replaceAll(/"/g, '""') + '"' : r.modelName;
                }
                if (r.modelDesc) {
                    r.modelDesc = (r.modelDesc.includes(",") || r.modelDesc.includes('"'))? '"' + r.modelDesc.replaceAll(/"/g, '""') + '"' : r.modelDesc;
                }
                if (r.securityDescription) {
                    r.securityDescription = (r.securityDescription.includes(",") || r.securityDescription.includes('"'))? '"' + r.securityDescription.replaceAll(/"/g, '""') + '"' : r.securityDescription;
                }
            });
            return res;
        };
        if (columnKeys.length === 0) {columnKeys = null;}
        let exportData = JSON.parse(JSON.stringify(this.data));
        this.ges.setPrefix("Model_History", "csv");
        this.ges.setExportOptions(formatter(exportData), this.grid.api, this.gridOptions, colDef, columnKeys);
    }
}
